<template>
    <div class="text-base" data-cy="tribal-summary-period">
        <span class="">Sum</span>
        <span class="text-lg ml-2">{{ formattedDate(fromDate) }} - {{ formattedDate(toDate) }} </span>
    </div>
</template>

<script setup lang="ts">
import {computed, Ref} from 'vue'
import {formattedDate} from '@/services/formatter.service'

const props = defineProps({
    params: {
        type: Object as () => {
            context: {
                searchParams: Ref<{
                    fromDate: string,
                    toDate: string
                }>,
            }
        },
        required: true
    }
})

const fromDate = computed(() => props.params.context.searchParams.value.fromDate)
const toDate = computed(() => props.params.context.searchParams.value.toDate)

</script>

<style scoped>

</style>